import { render } from "./TabList.vue?vue&type=template&id=58296176&scoped=true"
import script from "./TabList.vue?vue&type=script&lang=js"
export * from "./TabList.vue?vue&type=script&lang=js"

import "./TabList.vue?vue&type=style&index=0&id=58296176&lang=less&scoped=true"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58296176"]])

export default __exports__